import React from 'react';
import { Typo } from 'uikit/content';

const VersioningComposeTitle = ({
  value,
}) => (
  <Typo variant="h1">
    {value}
  </Typo>
);

export default React.memo(VersioningComposeTitle);
